export enum RequestViewByType {
  DETAILS = 'details',
}

export enum RequestReturnType {
  FULL_RECORD_AS_ARRAY = 'full_record_as_array',
}
